export const VERSION = '1.1.7-1'

export const SHOWN_TAGS = [
    'Muslim_owned',
    'Halal Certified',
    'Vegetarian',
    'Vegan',
    'Dairy',
    'Beef',
    'Seafood',
    'Pork/Lard',
    'Chicken',
    'Duck',
    'Lamb',
    'Fish',
    'Veg',
    'Pork',
]

export const BANNER_ITEMS = [
    {
        src: 'https://images.pexels.com/photos/17308455/pexels-photo-17308455/free-photo-of-a-sushi-roll-with-a-slice-of-lemon-and-a-slice-of-avocado.jpeg?auto=compress&cs=tinysrgb&w=1200',
        alt: 'Sushi Roll',
    },
    {
        src: 'https://images.pexels.com/photos/17308547/pexels-photo-17308547/free-photo-of-a-bowl-of-rice-with-meat-and-vegetables.jpeg?auto=compress&cs=tinysrgb&w=1200',
        alt: 'Rice Bowl',
    },
    {
        src: 'https://images.pexels.com/photos/17308560/pexels-photo-17308560/free-photo-of-a-bowl-of-food-with-meat-and-vegetables.jpeg?auto=compress&cs=tinysrgb&w=1200',
        alt: 'Delicious Food',
    },
]

export const CATEGORIES = ['Main', 'Side', 'Vegetable', 'Staple', 'Dessert', 'Drink']

export const BLOCKS_CART_PAGE = ['order', 'payment', 'payment-complete', 'checkout-assistant']

export const DINING_METHOD = {
    DineIn: 'DineIn',
    Takeaway: 'Takeaway',
}

export const DINING_METHOD_OPTIONS = [
    { value: DINING_METHOD.DineIn, label: 'Dine In' },
    { value: DINING_METHOD.Takeaway, label: 'Takeaway' },
]

export const PRODUCT_SELECTION_TYPE = {
    NORMAL: 'NORMAL', // for normal selection type (>0)
    SINGLE: 'SINGLE', // Optional (maximum 1 selection) (-1)
    MULTIPLE: 'MULTIPLE', // Optional (no maximum selection) (-2)
    MINIMUM: 'MINIMUM', // Minimum 2 or more selections required (-3)
    TAKEAWAY: 'TAKEAWAY', // Takeaway special options (required when dine-in is false) (-4)
}

export const SINGLE_SELECTION = [PRODUCT_SELECTION_TYPE.SINGLE, PRODUCT_SELECTION_TYPE.TAKEAWAY]

export const INVENTORY_STATUS = {
    ACTIVE: 'ACTIVE',
    CHECK_AVAILABLE: 'CHECK_AVAILABLE',
    SOLD_OUT: 'SOLD_OUT',
}

export const ORDER_STATUS = {
    UNPAID: 'Unpaid',
    PAID: 'Paid',
    COMPLETED: 'Completed',
}

export const GST_STALL_LIST = ['Tian Tian']

export const PAYMENT_METHOD = {
    Cash: 'CASH',
    PayNow: 'PAYNOW',
}

export const PAYMENT_METHOD_OPTIONS = [
    { value: PAYMENT_METHOD.Cash, label: 'Cash' },
    { value: PAYMENT_METHOD.PayNow, label: 'PayNow' },
]

export const PUB_SUB_EVENT = {
    // NEW_ORDER: 'new_order',
    // VOID_ORDER: 'void_order',
    COMPLETED_ORDER: 'completed_order',
    ORDER_PAYMENT_STATUS_UPDATE: 'order_payment_status_update',
    INVENTORY_STATUS_UPDATE: 'inventory_status_update',
    COMPLETED_DISH: 'completed_dish',
}

export const PUBSUB_GROUP_EVENT = {
    PING_GROUP: 'ping_group',
    PAYMENT_LATER: 'payment_later',
    PAYMENT_REQUEST: 'payment_request',
    PAYMENT_PAYNOW_SUCCESS: 'payment_paynow_success',
    PAYMENT_SUCCESS: 'payment_success',
    PAYMENT_FAILED: 'payment_failed',
    PAYMENT_CANCEL: 'payment_cancel',
    CART_SNAPSHOT: 'cart_snapshot',
}
